import { ListStyle } from '@orcar/common-d2c';
import styled from 'styled-components';
import * as S from '../styles';

const ReservationInfo = () => {
  return (
    <S.Wrapper>
      <S.Title type='page'>예약금 안내 및 취소・환불 규정</S.Title>
      <S.Section type='main'>
        <S.Title type='reservation'>[예약금 및 취소・환불 규정 안내]</S.Title>

        <S.Section type='paragraph'>
          <S.Title type='section'>
            1. 예약금은 결제 금액에 따라 변동됩니다.
          </S.Title>

          <S.Section type='text'>
            <S.Text type='main'>
              {`- 단, 10만원 이내인 경우 전액 결제
                - 결제금액 10만원부터 예약금 1만원씩 증가
                
                (예시)
                  결제금액 10만원 ~ 20만원까지: 예약금 1만원
                  결제금액 20만원 ~ 30만원까지: 예약금 2만원 
                  결제금액 30만원 ~ 40만원까지: 예약금 3만원`}
            </S.Text>
          </S.Section>
        </S.Section>

        <S.Section type='paragraph'>
          <S.Title type='section'>
            2. 취소 및 환불 접수는 당사 근무시간(08:00~19:00)에만 가능합니다.
          </S.Title>

          <S.Section type='text'>
            <S.Text type='main'>
              - 주말, 공휴일에도 취소 접수는 가능하며, 환불 처리 기간은 은행
              영업일 기준 3~4일 정도 소요됩니다.
            </S.Text>
          </S.Section>
        </S.Section>

        <S.Section type='paragraph'>
          <S.Title type='section'>
            3. 임차 기간 중 렌트카 사고로 인한 계약 해지 또는 임차인 사정으로
            인한 조기 반납 시 남은 잔여 대여료는 환불되지 않습니다.
          </S.Title>
        </S.Section>
      </S.Section>

      <S.Section type='main'>
        <S.Title type='reservation'>[예약금 환불 기준 안내]</S.Title>
        <S.TableWrapper>
          <S.Table width='360px'>
            <thead>
              <S.TableRow height='51px'>
                <S.Th width='285px'>취소 시점</S.Th>
                <S.Th width='160px'>환불 금액</S.Th>
              </S.TableRow>
            </thead>
            <tbody>
              <S.TableRow>
                <S.Td>인수일 기준 24시간 이전 취소 시</S.Td>
                <S.Td>100% 환불</S.Td>
              </S.TableRow>
              <S.TableRow>
                <S.Td>인수일 기준 24시간 이내 취소 시</S.Td>
                <S.Td>90% 환불</S.Td>
              </S.TableRow>
              <S.TableRow>
                <S.Td>인수 시간이 지난 경우</S.Td>
                <S.Td>환불 불가</S.Td>
              </S.TableRow>
            </tbody>
          </S.Table>
        </S.TableWrapper>
      </S.Section>
    </S.Wrapper>
  );
};

export default ReservationInfo;
